import React, { useState } from "react";

import { UilSearch, UilLocationPoint } from "@iconscout/react-unicons";
import { toast } from "react-toastify";

const SearchLocation = ({ setQuery, units, setUnits }) => {
  const [location, setLocation] = useState("");

  const handleSearch = () => {
    location && setQuery({ q: location });
  };

  const handleUnitsChange = (e) => {
    const selectedValue = e.currentTarget.name;
    if (units !== selectedValue) {
      setUnits(selectedValue);
    }
  };

  const LocationClickHandler = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        let lat = pos.coords.latitude;
        let lon = pos.coords.longitude;

        setQuery({
          lat,
          lon,
        });
      });
    }
  };

  return (
    <div className="flex flex-row justify-center my-6">
      <div className="flex flex-row w-3/4 items-center justify-center space-x-5">
        <input
          type="text"
          placeholder="Seach a city..."
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          className="text-thin font-light p-2 w-full shadow-xl capitalize focus:outline-none rounded-lg text-stone-600 focus:font-semibold placeholder:text-stone-400 placeholder:font-normal placeholder:lowercase"
        />

        <UilSearch
          className="text-white cursor-pointer transition ease-in-out hover:scale-125"
          size={30}
          onClick={handleSearch}
        />
        <UilLocationPoint
          className="text-white cursor-pointer transition ease-in-out hover:scale-125"
          size={30}
          onClick={LocationClickHandler}
        />
      </div>

      <div className="flex flex-row w-1/4 items-center justify-center divide-x ">
        <button
          name="metric"
          className="text-xl text-white font-light px-2 hover:scale-110 transition ease-in-out"
          onClick={handleUnitsChange}
        >
          °C
        </button>
        <button
          name="imperial"
          className="text-xl text-white font-light px-2 hover:scale-110 transition ease-in-out"
          onClick={handleUnitsChange}
        >
          °F
        </button>
      </div>
    </div>
  );
};

export default SearchLocation;
